import React from "react";

const StepSix=()=>{
    return (
        <>
            <div className="stepper__body stepper__position">
                <div className="stepper__container">
                    <div className="stepper__laststep">
                        <h2>Dziękujemy za przesłanie formularza Na maila prześlemy wszelkie informacje o odbiorze.</h2>
                    </div>
                </div>
            </div>
        </>
    )
}

export default StepSix;